const access_international_files = {
    mixins: [mixins],
    data() {
        return {
            terms: false,
            modal: "",
            model: {},
				touched: false
        };
    },
    created() {
        axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    },
    mounted() {

        this.resetForm();
        this.loading = false;

        this.handler = this.getFormAction(this.$refs.form);

        jQuery(document).on("modal-triggered", (ev, data) => {
			  
            if (this.modal === data.modalId)
                this.model.MediaNodeId = data.lnk.attr("data-id");
        });

        var myModalEl = document.getElementById(this.modal);
        myModalEl.addEventListener("hide.bs.modal", (event) => {
			this.resetForm();
            
        });
    },
    methods: {
        resetUnobstrusive() {
            var form = jQuery(this.$refs.form)
                .removeData(
                    "validator"
                ) /* added by the raw jquery.validate plugin */
                .removeData(
                    "unobtrusiveValidation"
                ); /* added by the jquery unobtrusive plugin*/
            jQuery.validator.unobtrusive.parse(form);

				var validator = jQuery(this.$refs.form).validate();
            console.log(validator)
            validator.resetForm();

				form.find('.field-validation-error:not(.not-unobstrusive)').removeClass('field-validation-error').addClass('field-validation-valid').html("")
        },

        resetForm() {
				this.touched = false
				this.terms = false
        
				this.model = {
					Country: "",
					MediaNodeId: "",
                    PostalCode: ""
				}

            this.$nextTick(() => {
                this.resetUnobstrusive();
            });
        },

        async submitForm() {
				this.touched = true

				
				console.log(this.model.MediaNodeId)

            if (!jQuery(this.$refs.form).valid()) {
                return false;
            }

            this.errorMsgs = [];
            this.loading = true;


            try {
                var response = await axios.post(this.handler, {
                    ...this.model,
                });
                if (!response.data.hasError) {
                    this.handleSuccess(response.data.url);
                } else {
                    this.handleError(response.data.errorMessages);
                }
            } catch (errors) {
                this.loading = false;
                this.handleError([errors.message]);
            }

            return false;
        },
        handleSuccess: function (url) {
            this.loading = false;

            this.errorMsgs = [];

            api.fn.downloadFile(url);

            this.$nextTick(() => {
                this.$refs.form.reset(); // This will clear that form
                api.fn.modal(this.modal, false);
            });
        },
        handleError: function (messages) {
            this.loading = false;

            this.errorMsgs = this.hasValue(messages) ? messages : [];
        },
    },
    watch: {
        "model.Country": {
            handler(val, oldVal) {
                this.errorMsgs = [];
            },
            //deep: true
        },
    },
};

const accessInternationalFilesApp = Vue.createApp(access_international_files);
const accessInternationalFilesAppSelector = "#access-international-files-app";

if (document.querySelector(accessInternationalFilesAppSelector)) {
    accessInternationalFilesApp
        .directive("init", initDirective)
        .component("alert-danger", alertDanger)
        .mount(accessInternationalFilesAppSelector);
}
